import { apiRequest, apiEndPoints, methodType } from "./_apiConfig";

export const getBusinessKycRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.getBusinessKyc,
    data,
    true,
    true
  );
};

export const postBusinessKycRequest = async (data = {}) => {
  return apiRequest(
    methodType.POST,
    apiEndPoints.postBusinessKYC,
    data,
    true,
    true
  );
};

export const patchBusinessKycRequest = async (kycId, data = {}) => {
  return apiRequest(
    methodType.PATCH,
    apiEndPoints.updateBusinessKYC(kycId),
    data,
    true,
    true
  );
};
